export default {
    image(uid, directory = 'portfolio', ext = 'x300') {
        if (uid) {
            return 'https://s3-eu-west-1.amazonaws.com/images.castcall.blue-compass.com/' + directory + '/' + Math.floor(uid / 1000) + '/' + uid + ext + '.jpg';
        }
        return 'https://d3ul5arn36jez0.cloudfront.net/images/defaults/candidate.jpg';
    },
    getProfileUrl(user = '') {
        if(typeof user == "string") {
            return this.prefixedUrl('mandy.com' + user)
        }

        return this.prefixedUrl('mandy.com' + user.profile_url)
    },
    prefixedUrl(url = '') {
        // local
        if (`${window.prefix}` == 'http://local.' || `${window.prefix}` == 'https://dev.') {
            return this.filterDoubleWww(`${window.prefix}${url}`);
        }

        // mandy
        if (url.startsWith('mandy.com')) {
            return this.filterDoubleWww(`${window.prefix}www.${url}`);
        }

        // fixed url (just in case)
        if (url.startsWith('https://') || url.startsWith('http://') || url.startsWith('//')) {
            return this.filterDoubleWww(url);
        }

        // fallback
        return this.filterDoubleWww(`${window.prefix}${url}`);
    },
    filterDoubleWww(url = '') {
        return url.replace('www.www.', 'www.');
    }
}